import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import { Production } from '../../system/environment';

const myOtherApp = 'myOtherApp';

const config = Production
  ? {
      apiKey: process.env.REACT_APP_PROD_UNIVERSIA_APIKEY,
      authDomain: process.env.REACT_APP_PROD_UNIVERSIA_AUTHDOMAIN,
      databaseURL: process.env.REACT_APP_PROD_UNIVERSIA_DATABASEURL,
      projectId: process.env.REACT_APP_PROD_UNIVERSIA_PROJECTID,
      storageBucket: process.env.REACT_APP_PROD_UNIVERSIA_STORAGEBUCKET,
      messagingSenderId: process.env.REACT_APP_PROD_UNIVERSIA_MESSAGINGSENDERID,
      appId: process.env.REACT_APP_PROD_UNIVERSIA_APPID,
      measurementId: process.env.REACT_APP_PROD_UNIVERSIA_MEASUREMENTID,
    }
  : {
      apiKey: process.env.REACT_APP_DEV_UNIVERSIA_APIKEY,
      authDomain: process.env.REACT_APP_DEV_UNIVERSIA_AUTHDOMAIN,
      databaseURL: process.env.REACT_APP_DEV_UNIVERSIA_DATABASEURL,
      projectId: process.env.REACT_APP_DEV_UNIVERSIA_PROJECTID,
      storageBucket: process.env.REACT_APP_DEV_UNIVERSIA_STORAGEBUCKET,
      messagingSenderId: process.env.REACT_APP_DEV_UNIVERSIA_MESSAGINGSENDERID,
      appId: process.env.REACT_APP_DEV_UNIVERSIA_APPID,
      measurementId: process.env.REACT_APP_DEV_UNIVERSIA_MEASUREMENTID,
    };

const secondConfig = Production
  ? {
      apiKey: process.env.REACT_APP_PROD_PIEZA_APIKEY,
      authDomain: process.env.REACT_APP_PROD_PIEZA_AUTHDOMAIN,
      databaseURL: process.env.REACT_APP_PROD_PIEZA_DATABASEURL,
      projectId: process.env.REACT_APP_PROD_PIEZA_PROJECTID,
      storageBucket: process.env.REACT_APP_PROD_PIEZA_STORAGEBUCKET,
      messagingSenderId: process.env.REACT_APP_PROD_PIEZA_MESSAGINGSENDERID,
      appId: process.env.REACT_APP_PROD_PIEZA_APPID,
    }
  : {
      apiKey: process.env.REACT_APP_DEV_PIEZA_APIKEY,
      authDomain: process.env.REACT_APP_DEV_PIEZA_AUTHDOMAIN,
      databaseURL: process.env.REACT_APP_DEV_PIEZA_DATABASEURL,
      projectId: process.env.REACT_APP_DEV_PIEZA_PROJECTID,
      storageBucket: process.env.REACT_APP_DEV_PIEZA_STORAGEBUCKET,
      messagingSenderId: process.env.REACT_APP_DEV_PIEZA_MESSAGINGSENDERID,
      appId: process.env.REACT_APP_DEV_PIEZA_APPID,
    };

firebase.initializeApp(config);
firebase.initializeApp(secondConfig, myOtherApp);
const database = firebase.firestore();
const secondDatabase = firebase.app(myOtherApp).firestore();
const secondStorage = firebase.app(myOtherApp).storage();
const storage = firebase.storage();

export { firebase, storage, secondDatabase, secondStorage, database as default };
